import { getColSpan } from '../../utils/getColSpan.js';
const MIN_COL_SPAN = 10;
export const getPaddings = (className) => getColSpan(className) < MIN_COL_SPAN ? 'py-xl px-6xl' : 'py-6xl px-32';
//# sourceMappingURL=getPaddings.js.map